export default __webpack_public_path__ + "static/media/goopter-use-case-hotel-service-automation.3cb781f8.jpg";